'use strict';

var _ = require('lodash');

var metaDescriptions = {
  login: 'Log in for SixPlus to access your account and submit requests for private dining spaces at the most exclusive venues.',
  register: 'Register for SixPlus and easily book a private dining space for your group event.',
  about: 'Learn the story behind SixPlus, meet our team, discover new job opportunities and get in touch with us with any inquiries you may have.',
  account: 'SixPlus simplifies private dining. Use your account to manage your bookings, contact restaurants, inquire about availability and customize your event packages.',
  concierge: 'Planning a private event? Tell us the details and we\'ll send you a custom list of private dining options from the finest restaurants and venues in your city.',
  faq: 'Here are answers to common questions asked about SixPlus, both by private dining customers and restaurant owners and employees.',
  home: 'SixPlus is like OpenTable for groups. Our website helps you find and book the best private and semi-private spaces for private group dining events of 6 or more guests.',
  privacy: 'Read SixPlus\’s privacy policy to understand how we collect, use, communicate and disclose the personal information of our users.',
  search: function search(location) {
    return locationToDescription[location];
  },
  terms: 'Read more for detailed information regarding SixPlus\’s Terms of Use. By accessing our servers, websites, or content therefrom users agree to these Terms of Use.',
  venueBook: function venueBook(venueName) {
    return 'Book your private space exactly how you want it, complete with custom menus and add-ons. In a few clicks, you can submit a request for ' + venueName + '. Private dining made easy.';
  },
  venueView: function venueView(venueName, venueTagline) {
    return 'Discover private dining options from ' + venueName + '. ' + venueTagline + (_.endsWith(venueTagline, '.') ? '' : '.');
  }

};

var locationToDescription = {
  'New York': 'Find venues for private dinners, corporate events and parties in the New York area. Browse by location, budget, group size, cuisine and more.',
  'Washington DC': 'Browse venues for private seated meals, corporate events and other celebrations in the Washington, DC area. Filter your search by location, budget, group size, cuisine and more.',
  'Boston': 'Browse the best private venues in the Boston area for corporate events, seated meals, celebrations, showers, birthdays and more. Book private spaces online.'
};

module.exports = metaDescriptions;